import React, { useRef } from "react";

import DropDown from "2g-dropdown";
import { useToggler } from "2g-hooks";

import { UserInfoIcon as UserInfoIconComponent } from "2g-auth";

import { LogoutIcon } from "2g-auth";
import { LangSwitchRow, LangSwitchItem } from "2g-intl";
import { LANGUAGE } from "2g-i18n";

export function UserInfoIcon() {
  const elementRef = useRef();
  const [isVisible, toggleVisible, setVisible] = useToggler();

  return (
    <div onClick={toggleVisible} ref={elementRef} className="b2b-UserInfoIcon">
      <UserInfoIconComponent />
      <DropDown
        className="b2b-UserInfoIcon-dropDown"
        elementRef={elementRef}
        isVisible={isVisible}
        setVisible={setVisible}
        preventClick={false}
      >
        <div className="b2b-UserInfoIcon-dropDownContent">
          <LangSwitchRow>
            <LangSwitchItem lang={LANGUAGE.CZECH}>
              {LANGUAGE.CZECH}
            </LangSwitchItem>
            <LangSwitchItem lang={LANGUAGE.ENGLISH}>
              {LANGUAGE.ENGLISH}
            </LangSwitchItem>
          </LangSwitchRow>

          <LogoutIcon />
        </div>
      </DropDown>
    </div>
  );
}

UserInfoIcon.propTypes = {};

export default React.memo(UserInfoIcon);
